import type { GatewayConfig } from '@/core/api'

import type { GatewayUserSettings } from './interfaces/gatewayUserSettings.interface'
import { isLocalGatewayConfigurationMode } from './isLocalGatewayConfigurationMode'

export function mergeGatewayUserSettings(baseConfig: GatewayConfig, userSettings: GatewayUserSettings): GatewayConfig {
  if (!isLocalGatewayConfigurationMode() || !userSettings.useCustom) {
    return baseConfig
  }

  return {
    host: userSettings.host?.trim() || baseConfig.host,
    port: userSettings.httpPort?.trim() || baseConfig.port,
    isSecured: baseConfig.isSecured,
  }
}
